import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from "@/features/personal/pages/LoginPage.vue";
import RegisterPage from "@/features/personal/pages/RegisterPage.vue";
import ConfirmPage from "@/features/personal/pages/ConfirmPage.vue";
import RecoverPage from "@/features/personal/pages/RecoverPage.vue";
import AuthLayout from "@/layouts/AuthLayout.vue";
import AccountsPage from "@/features/accounts/pages/AccountsPage.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import NotFound from "@/layouts/NotFound.vue";
import TransactionsPage from "@/features/transactions/pages/TransactionsPage.vue";
import CategoriesPage from "@/features/categories/pages/CategoriesPage.vue";
import PersonalPage from "@/features/personal/pages/PersonalPage.vue";
import PlansPage from "@/features/plans/pages/PlansPage.vue";
import PlanDetailPage from "@/features/plans/pages/PlanDetailPage.vue";
import DashboardPage from "@/features/dashboard/pages/DashboardPage.vue";
import * as apiDashboard from '@/api/dashboard';
import * as apiAccounts from '@/api/accounts';
import RecoverSendPage from "@/features/personal/pages/RecoverSendPage.vue";
import OauthPage from "@/features/personal/pages/OauthPage.vue";
import PublicLayout from "@/layouts/PublicLayout.vue";
import HomePage from "@/features/public/pages/HomePage.vue";
import PrivacyPage from "@/features/public/pages/PrivacyPage.vue";
import TermsPage from "@/features/public/pages/TermsPage.vue";
import {ref} from "vue";
import {checkAuth} from "@/api/http";

const routes = [
    {
        path: '/',
        component: PublicLayout,
        children: [
            { path: '', name: 'home', component: HomePage },
            { path: 'privacy', name: 'privacy', component: PrivacyPage },
            { path: 'terms', name: 'terms', component: TermsPage },
            { path: 'oauth/success', component: OauthPage}
        ],
    },
    {
        path: '/',
        component: AuthLayout,
        children: [
            { path: 'auth', component: LoginPage, name: 'Login' },
            { path: 'register', component: RegisterPage },
            { path: 'confirm', component: ConfirmPage },
            { path: 'recover', component: RecoverSendPage },
            { path: 'recover/:token', component: RecoverPage, props: true },
        ],
        meta: { unauthorized: true },
    },
    {
        path: '/',
        component: MainLayout,
        children: [
            {
                path: 'dashboard',
                name: 'DashboardRoot',
                meta: {menu: { name: "Dashboard", icon: "bi bi-house"} },
                beforeEnter: async (to, from, next) => {
                    const currencies = await apiDashboard.currencies();
                    if (!currencies.length) {
                        return next('/accounts');
                    }
                    return next(`/dashboard/${currencies[0]}`);
                }
            },
            {
                path: 'dashboard/:currency',
                name: 'Dashboard',
                component: DashboardPage,
                props: true,
            },
            {
                path: 'accounts',
                name: 'Accounts',
                component: AccountsPage,
                meta: {menu: { name: "Счета", icon: "bi bi-bank"} }
            },
            {
                path: 'accounts/:accountId/transactions',
                component: TransactionsPage,
                name: "Transactions",
                props: true,
            },
            {
                path: "plans",
                component: PlansPage,
                name: "PlansList",
                meta: {menu: { name: "Планы", icon: "bi bi-list-stars"} },
                beforeEnter: async (to, from, next) => {
                    const data = await apiAccounts.listAccounts(1, 3);
                    const accounts = data?.content ?? [];
                    console.log(accounts);
                    if (!accounts.length) {
                        return next('/accounts');
                    }
                    return next();
                }
            },
            {
                path: "plans/:id",
                component: PlanDetailPage,
                name: "PlanDetail",
                props: true,
                beforeEnter: async (to, from, next) => {
                    const data = await apiAccounts.listAccounts(1, 3);
                    const accounts = data?.content ?? [];
                    console.log(accounts);
                    if (!accounts.length) {
                        return next('/accounts');
                    }
                    return next();
                }
            },
            {
                path: 'categories',
                component: CategoriesPage,
                meta: {menu: { name: "Категории", icon: "bi bi-folder2"} }
            },
            {
                path: 'personal',
                component: PersonalPage,
            },
        ],
        meta: { authorized: true }
    },
    // 404 not found page
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach(async (to, from, next) => {
    const authorized = to.matched.some(record => record.meta.authorized);
    const unauthorized = to.matched.some(record => record.meta.unauthorized);
    
    const isAuth = await checkAuth();
    
    if (authorized && !isAuth) {
        return next({
            name: 'Login',
            query: { redirect: to.fullPath },
        });
    }
    
    if (unauthorized && isAuth) {
        return next('/dashboard');
    }
    
    return next();
});

router.afterEach(() => {
    const isMobile = window.innerWidth < 1200;
    if (isMobile) {
        document.body.classList.remove('toggle-sidebar');
    }
});

export default router;
